module.exports = __webpack_public_path__ + "static/media/solutions-grid-4.216676f8.webp";